import React, { useState, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';
import { useSelector } from 'react-redux';
import { graphColors } from '../../helpers/meta';
import { Card, CardBody } from 'reactstrap';

const getLineOptions = (lengendsData, propertiesData, seriesData) => {
  return {
    title: {
      text: ''
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: lengendsData
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: propertiesData
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        margin: 40,
      }
    },
    series: seriesData,
  };
}

const Line = (props) => {
  const dataPoints = {};
  props.dataOptions.forEach(val => {
    dataPoints[val.value] = val.label;
  });
  const summary = useSelector(state => state.summary);
  const access = useSelector(state => state.auth.access);
  const [type, setType] = useState(props.type ? props.type : "line");
  const [option, setOptions] = useState(null);
  console.log('option',option);
  const loadingOption = {
    text: 'Loading...',
    color: '#4413c2',
    textColor: '#270240',
    maskColor: 'rgba(255, 255, 255, 0.3)',
    zlevel: 0
  };

  const onChartReady = (echarts) => {
    echarts.hideLoading();
  }

  useEffect(() => {

    let current = summary.current;
    let seriesData = [];
    let lengendsData = current.map((store, index) => {
      var _seriesData = { name: store.label, type: type, data: [], color: graphColors[index], barMaxWidth: 20, barMinWidth: 4 };
      if (props.stack) {
        _seriesData["stack"] = "Total";
      }
      Object.keys(dataPoints).forEach((key) => {
        _seriesData.data.push(store[key]);
      });
      seriesData.push(_seriesData);
      return store.label
    });
    let propertiesData = Object.keys(dataPoints).map((key) => {
      return dataPoints[key];
    });
    setOptions(getLineOptions(lengendsData, propertiesData, seriesData));

  }, [summary, props.dataOptions])

  return (
    option !== null &&
    <Card>
      <CardBody>
        <ReactECharts
          option={option}
          style={{ height: 400 }}
          onChartReady={onChartReady}
        />
      </CardBody>
    </Card>
  )
}
export default Line;